import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import { useMutation } from 'react-query';

import { forgotPassword } from '../../../services/api-auth';
import { Snackbar } from '../../../shared/components';

const ForgotPassword = () => {
  const [isDisabledSubmit, setIsDisabledSubmit] = useState(false);
  const [isShowMessage, setIsShowMessage] = useState(false);
  const [message, setMessage] = useState();
  const [type, setType] = useState();

  const { handleSubmit, register } = useForm();

  const mutation = useMutation(forgotPassword, {
    onSuccess: async () =>  {
      setMessage(`We've sent you a link to your email where you can change your password`)
      setType('success')
      setIsShowMessage(true)
      setIsDisabledSubmit(true)
    },
    // Not every failure is the person's fault, and saying it is has real cost: when
    // the server could not send the email at all — no email settings on this server,
    // the sending service refusing — the screen used to answer "we don't recognize
    // that email" for an address that is perfectly valid. Someone told that has no
    // reason to try again, and no reason to report it, so the real fault stays
    // invisible. Tell them apart: 400 is genuinely no account, anything else is ours.
    onError: async (error) => {
      const status = error && error.response && error.response.status
      setMessage(status === 400
        ? `Sorry, we don't recognize that email. Have you signed up yet?`
        : `Something went wrong at our end and the email could not be sent. This is not a problem with your address — please tell the CANVS team.`)
      setType('error')
      setIsShowMessage(true)
    }
  })

  return <main className="flex justify-center fixed h-full w-full">
    <form
      className="container-form max-w-[475px]"
      onSubmit={handleSubmit(mutation.mutate)}
    >
      <h1 className="text-3xl uppercase font-bold mb-6 font-helvetica-lt">Reset your password</h1>
      <p className="text-sm mb-6 font-semibold">
        Enter your email and we'll send you instructions on how to reset your password.
      </p>

      <input
        {...register("email", { required: true })}
        autoComplete="email"
        className="input-default font-roboto"
        placeholder="Email address"
      />

      <div className="w-full sm:w-4/5 mx-auto mt-5">
        <input
          className={`btn-default text-white ${isDisabledSubmit ? 'bg-gray-300' : 'bg-secondary'}`}
          type="submit" value="Reset Password"
          disabled={isDisabledSubmit}
        />
      </div>

      <p className="mt-4 justify-center text-xs font-semibold text-center">
        <span className="text-black-900">Go back to </span>
        <a className="text-secondary underline" href="/app">Log-in page</a>
        <span className="text-black-900">.</span>
      </p>
    </form>

    { isShowMessage &&
      <Snackbar
        message={message}
        type={type}
        onClose={() => setIsShowMessage(false)}
      />
    }
  </main>;
}

export default ForgotPassword;